import React from 'react';
import HeaderOne from './components/NavBar';
import Footer from './components/Footer';
import Scroll from './scrollToTop';
import { FacebookFilled, InstagramFilled, XOutlined, TikTokOutlined } from '@ant-design/icons';

export default function ContactSection() {
  return (
    <>
    <Scroll/>
    <HeaderOne/>
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
            <div>
              <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900">Get in touch</h2>
              <p className="mt-4 text-base/7 text-gray-600">
              Contact the team for any enquiries including support, partnership working, consultancy services and press.               </p>
            </div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
              <div className="rounded-2xl bg-gray-50 p-10">
                <h3 className="text-base/7 font-semibold text-gray-900">Collaborate</h3>
                <dl className="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt className="sr-only">Email</dt>
                    <dd>
                      <a href="mailto:customerservices@enablesend.co.uk" className="font-semibold text-indigo-600">
                      customerservices@enablesend.co.uk
                      </a>
                    </dd>
                  </div>
                  <div className="mt-4 flex gap-4">
                    <a href="https://www.facebook.com/profile.php?id=61557428587972" target="_blank" rel="noopener noreferrer">
                      <FacebookFilled style={{ fontSize: '24px', color: '#3b5998' }} />
                    </a>
                    <a href="https://www.instagram.com/enablesend?fbclid=IwZXh0bgNhZW0CMTAAAR1PL1Cp4BD_Wc6nkKNPY1YlWD7oAedkCZ2igdCUCAaNS1MwDmcje63fzpo_aem_lPkZ_hV4WYU2Uu03aKLRMg" target="_blank" rel="noopener noreferrer">
                      <InstagramFilled style={{ fontSize: '24px', color: '#E1306C' }} />
                    </a>
                    <a href="https://x.com/enablesend?fbclid=IwZXh0bgNhZW0CMTAAAR3GljV7-5ilFbMlx70x2sj-nYP1OMLdvJtDNQay6e7-SbWpF2s9y3H_QzY_aem_7stYq6XNRsdZWLC5lpLPpA" target="_blank" rel="noopener noreferrer">
                      <XOutlined style={{ fontSize: '24px', color: '#1DA1F2' }} />
                    </a>
                    <a href="https://www.tiktok.com/@enablesend?fbclid=IwY2xjawH-RadleHRuA2FlbQIxMAABHSWzIlXL09lSwWrT5BVZHjP44bx4-LS_DaR1UGS5fc4bPj1SfQXTl98fvA_aem_aas9WQk3rei0vbhRqJOIiA" target="_blank" rel="noopener noreferrer">
                      <TikTokOutlined style={{ fontSize: '24px', color: '#0077b5' }} />
                    </a>
                  </div>
                </dl>
              </div>
              {/* <div className="rounded-2xl bg-gray-50 p-10">
                <h3 className="text-base/7 font-semibold text-gray-900">Support</h3>
                <dl className="mt-3 space-y-1 text-sm/6 text-gray-600">
                  <div>
                    <dt className="sr-only">Email</dt>
                    <dd>
                      <a href="mailto:press@example.com" className="font-semibold text-indigo-600">
                      Support@example.com
                      </a>
                    </dd>
                  </div>
                  <div className="mt-1">
                    <dt className="sr-only">Phone number</dt>
                    <dd>+1 (555) 905-3456</dd>
                  </div>
                </dl>
              </div> */}
              {/* <div className="rounded-2xl bg-gray-50 p-10">
                <h3 className="text-base/7 font-semibold text-gray-900">Los Angeles</h3>
                <address className="mt-3 space-y-1 text-sm/6 not-italic text-gray-600">
                  <p>4556 Brendan Ferry</p>
                  <p>Los Angeles, CA 90210</p>
                </address>
              </div>
              <div className="rounded-2xl bg-gray-50 p-10">
                <h3 className="text-base/7 font-semibold text-gray-900">Los Angeles</h3>
                <address className="mt-3 space-y-1 text-sm/6 not-italic text-gray-600">
                  <p>4556 Brendan Ferry</p>
                  <p>Los Angeles, CA 90210</p>
                </address>
              </div> */}
            </div>
          </div>
          
        
        </div>
      </div>
    </div>

    <Footer/>
    </>
  );
}
